import { supabase } from "@/integrations/supabase/client";

const BUCKET_NAME = "article-images";
const PUBLIC_URL_MARKER = `/object/public/${BUCKET_NAME}/`;

/**
 * Convert a Supabase Storage public URL into a signed URL.
 * Non-storage URLs (local assets, external images) are returned unchanged.
 */
export async function signArticleImageUrl(imageUrl: string): Promise<string> {
  if (!imageUrl || !imageUrl.includes(PUBLIC_URL_MARKER)) {
    return imageUrl;
  }

  const path = imageUrl.split(PUBLIC_URL_MARKER)[1]?.split("?")[0];
  if (!path) return imageUrl;

  const { data, error } = await supabase.storage
    .from(BUCKET_NAME)
    .createSignedUrl(path, 60 * 60 * 24 * 7); // 7 days

  if (error || !data?.signedUrl) {
    console.error("Failed to create signed URL for article image:", error);
    return imageUrl;
  }

  return data.signedUrl;
}

/**
 * Sign all Supabase Storage image URLs in a list of articles in parallel.
 */
export async function signArticleImageUrls<T extends { image: string }>(
  articles: T[]
): Promise<T[]> {
  return Promise.all(
    articles.map(async (article) => ({
      ...article,
      image: await signArticleImageUrl(article.image),
    }))
  );
}
